import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { fadeUp, viewportOnce, stagger } from "../lib/motion";
import { HOME_COMMITMENTS } from "../lib/site";
import { AI_TRANSPARENCY_NOTE } from "../lib/about";

const HomeTrust = () => (
    <section
        data-testid="home-trust-section"
        className="relative border-y border-white/10 bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    TRUST &amp; TRANSPARENCY
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="home-trust-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-white md:text-6xl"
            >
                Better decisions begin with better information
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-5"
            >
                {HOME_COMMITMENTS.map((c, i) => (
                    <motion.div
                        key={c.title}
                        variants={fadeUp}
                        data-testid={`home-commitment-${i + 1}`}
                        className="border-t border-white/15 pt-5"
                    >
                        <h3 className="font-mono text-[13px] tracking-[0.24em] text-accent">
                            {c.title}
                        </h3>
                        <p className="mt-4 text-[14px] leading-relaxed text-mist">
                            {c.copy}
                        </p>
                    </motion.div>
                ))}
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-14 flex flex-wrap items-center justify-between gap-6 border-t border-white/10 pt-8"
            >
                <p className="max-w-2xl font-mono text-[13px] leading-relaxed tracking-[0.14em] text-mist/80">
                    {AI_TRANSPARENCY_NOTE}
                </p>
                <Link
                    to="/trust"
                    data-testid="home-trust-link"
                    className="group inline-flex items-center gap-2 text-[15px] font-semibold text-accent transition-colors duration-300 hover:text-[#ff7026]"
                >
                    Read our full commitments
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
            </motion.div>
        </div>
    </section>
);

export default HomeTrust;
